module.exports = __webpack_public_path__ + "dist/assets/931e10c208272004a266548b8f1373b5.png";